import { Box } from "@mantine/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "config/redux";

import { Button, Modal, Text } from "components";
import { ServiceConstants } from "constant";import { ControlService } from "services";
import { AppUtils } from "utils";;

const { REQUEST_PENDING, REQUEST_CONTROL_F3 } = ServiceConstants;

const title = "F3: Zapamti defaultnu bazu";

const F3SaveDatabase = () => {
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CONTROL_F3]);
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);
  const submit = useCallback(() => ControlService.saveDatabase(), []);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_CONTROL_F3, () => setModalVisible(false));
  }, [serviceObject]);
  return (
    <>
      <Button variant={'subtle'} onClick={() => setModalVisible(true)}>{title}</Button>
      <Modal opened={modalVisible} onClose={() => !isLoading ? setModalVisible(false) : {}} title={title} style={{ overflowY: 'auto' }}>
        <Text>Da li ste sigurni?</Text>
        <Box mt={40}>
          <Button
            fullWidth={true}
            disabled={isLoading}
            loading={isLoading}
            onClick={submit}
          >
            {'Potvrdi'}
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default F3SaveDatabase;